module.exports = __webpack_public_path__ + "images/emoji/sagittarius.1562550ce5636675134d.png";